export const FORM_NAME = 'ClientRiskLevelAddForm'
export const MODAL_NAME = 'ClientRiskLevelAddModal'
